import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ConfirmationModal } from 'seagull';
import { isUrlValid } from "./IntroVIdeoModal.utils";
import { isStatusSuccess } from "../../../../VideoPlayer/VideoPlayer";
import IntroVideoModalContent from "./IntroVideoModalContent";
import { jsx as _jsx } from "react/jsx-runtime";
const IntroVideoModal = _ref => {
  let {
    dismissModal,
    onSave,
    videoLink
  } = _ref;
  const form = useForm({
    mode: 'all',
    defaultValues: {
      videoLink: videoLink || ''
    }
  });
  const [inputVideoName, setInputVideoName] = useState('');
  const [videoPlayableStatus, setVideoPlayableStatus] = useState();
  const onSubmit = () => {
    const inputVideoLink = form.getValues('videoLink');
    if (isUrlValid(inputVideoLink) && isStatusSuccess(videoPlayableStatus)) {
      onSave(inputVideoName, inputVideoLink);
      dismissModal();
    }
  };
  const onCancel = () => {
    dismissModal();
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    "data-testid": "intro-video-modal",
    textAlignCenter: false,
    title: "Add an introductory video",
    secondaryButtonTestid: "intro-video-modal-cancel-button",
    onSecondaryButtonClick: onCancel,
    primaryButtonTestid: "intro-video-modal-save-button",
    onPrimaryButtonClick: onSubmit,
    onCloseButtonClick: onCancel,
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    content: /*#__PURE__*/_jsx(IntroVideoModalContent, {
      form: form,
      setInputVideoName: setInputVideoName,
      setVideoPlayableStatus: setVideoPlayableStatus,
      videoPlayableStatus: videoPlayableStatus
    })
  });
};
export default IntroVideoModal;